export default __webpack_public_path__ + "static/media/plus.5897f44c.jpg";